/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const customTextTokens = {
  BackgroundColorMonospaceDefault: '#ebecec',
  FontColorPositiveDefault: '#237c70',
  FontColorNegativeDefault: '#c41936',
  FontColorNeutralDefault: '#656b6b',
  FontColorBlackDefault: '#1c2222',
  FontColorGrayDefault: '#656b6b',
  FontColorWhiteDefault: '#ffffff',
  FontColorBlueDefault: '#285da3',
  FontColorRedDefault: '#c41936',
  FontColorGreenDefault: '#2d9e90',
  FontColorBodyDefault: '#1c2222',
  FontColorMonospaceDefault: '#232b2b',
  FontFamilyDisplay1Default: '"Inter var", "fallback for Inter", sans-serif',
  FontFamilyDisplay2Default: '"Inter var", "fallback for Inter", sans-serif',
  FontFamilyHeading1Default: '"SangBleu Versailles", "fallback for SangBleu", serif',
  FontFamilyHeading2Default: '"Inter var", "fallback for Inter", sans-serif',
  FontFamilyHeading3Default: '"Inter var", "fallback for Inter", sans-serif',
  FontFamilyHeading4Default: '"Inter var", "fallback for Inter", sans-serif',
  FontFamilyBody1Default: '"Inter var", "fallback for Inter", sans-serif',
  FontFamilyBody2Default: '"Inter var", "fallback for Inter", sans-serif',
  FontFamilyBody3Default: '"Inter var", "fallback for Inter", sans-serif',
  FontFamilySmall1Default: '"Inter var", "fallback for Inter", sans-serif',
  FontFamilySmall2Default: '"Inter var", "fallback for Inter", sans-serif',
  FontFamilyMonospaceDefault: '"Roboto Mono", ui-monospace, Menlo, Monaco, monospace',
  FontSizeDisplay1Default: '28px',
  FontSizeDisplay2Default: '24px',
  FontSizeHeading1DefaultDesktop: '28px',
  FontSizeHeading1DefaultMobile: '24px',
  FontSizeHeading2DefaultDesktop: '20px',
  FontSizeHeading2DefaultMobile: '18px',
  FontSizeHeading3Default: '16px',
  FontSizeHeading4Default: '16px',
  FontSizeBody1Default: '14px',
  FontSizeBody2Default: '14px',
  FontSizeBody3Default: '14px',
  FontSizeSmall1Default: '12px',
  FontSizeSmall2Default: '12px',
  FontSizeMonospaceDefault: '13px',
  FontWeightDisplay1Default: '600',
  FontWeightDisplay2Default: '600',
  FontWeightHeading1Default: '400',
  FontWeightHeading2Default: '500',
  FontWeightHeading3Default: '500',
  FontWeightHeading4Default: '400',
  FontWeightBody1Default: '600',
  FontWeightBody2Default: '500',
  FontWeightBody3Default: '400',
  FontWeightSmall1Default: '500',
  FontWeightSmall2Default: '400',
  FontWeightMonospaceDefault: '400',
  FontLeadingDisplay1Default: '48px',
  FontLeadingDisplay2Default: '44px',
  FontLeadingHeading1DefaultDesktop: '48px',
  FontLeadingHeading1DefaultMobile: '40px',
  FontLeadingHeading2DefaultDesktop: '36px',
  FontLeadingHeading2DefaultMobile: '28px',
  FontLeadingHeading3Default: '28px',
  FontLeadingHeading4Default: '28px',
  FontLeadingBody1Default: '24px',
  FontLeadingBody2Default: '24px',
  FontLeadingBody3Default: '24px',
  FontLeadingSmall1Default: '20px',
  FontLeadingSmall2Default: '20px',
  FontLeadingMonospaceDefault: '24px',
  FontSpacingDisplay1Default: '16px',
  FontSpacingDisplay2Default: '16px',
  FontSpacingHeading1Default: '16px',
  FontSpacingHeading2Default: '16px',
  FontSpacingHeading3Default: '16px',
  FontSpacingHeading4Default: '16px',
  FontSpacingBody1Default: '8px',
  FontSpacingBody2Default: '8px',
  FontSpacingBody3Default: '8px',
  FontSpacingSmall1Default: '8px',
  FontSpacingSmall2Default: '8px',
} as const;
